import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

/**
 * Stimulus controller for toggling schema examples visibility.
 * Handles showing/hiding examples section and expanding schema to full width.
 */
export default class ExamplesToggleController extends Controller {
  static targets = ['examples', 'showText', 'hideText', 'container'];

  declare readonly examplesTarget: HTMLElement;
  declare readonly showTextTarget: HTMLElement;
  declare readonly hideTextTarget: HTMLElement;
  declare readonly containerTarget: HTMLElement;

  /**
   * Toggle the visibility of the examples section
   */
  toggle() {
    const isHidden = this.examplesTarget.classList.contains('hidden');

    if (isHidden) {
      // Show examples - restore 2-column layout
      this.examplesTarget.classList.remove('hidden');
      this.containerTarget.classList.remove('lg:grid-cols-1');
      this.containerTarget.classList.add('lg:grid-cols-2');
      this.showTextTarget.classList.remove('hidden');
      this.hideTextTarget.classList.add('hidden');
    } else {
      // Hide examples - expand to full width
      this.examplesTarget.classList.add('hidden');
      this.containerTarget.classList.remove('lg:grid-cols-2');
      this.containerTarget.classList.add('lg:grid-cols-1');
      this.showTextTarget.classList.add('hidden');
      this.hideTextTarget.classList.remove('hidden');
    }
  }
}

application.register('openapi-ui--schema--examples-toggle', ExamplesToggleController);
